/**
 * Overwrites the collection heading H1 with a filter-specific title when an
 * active filter matches a `filter_description` metaobject.
 *
 * The matched title is rendered server-side by sections/main-collection.liquid
 * into `#filter-h1-value[data-h1]`. That marker lives inside the collection
 * section (wrapper `#shopify-section-main`), so it is re-rendered when filters
 * update via AJAX.
 *
 * Rather than depend on a specific storefront event firing/bubbling at the
 * right time, we watch the collection section for DOM changes with a
 * MutationObserver and re-apply the H1 whenever the marker changes. We also
 * apply once on initial load and listen for `shopify:collection:update` as a
 * belt-and-braces fallback.
 *
 * The heading H1 lives in the dedicated "Collection heading" section (key
 * `section` in templates/collection.json), so its wrapper id is
 * `shopify-section-section`. We target that first, then fall back to the first
 * H1 on the page that is not inside the product results list.
 */
(function () {
  function findHeadingH1() {
    const scoped = document.querySelector('#shopify-section-section h1');
    if (scoped) return scoped;
    const all = document.querySelectorAll('h1');
    for (const el of all) {
      if (!el.closest('results-list, collection-component')) return el;
    }
    return all[0] || null;
  }

  function applyFilterH1() {
    const marker = document.querySelector('#filter-h1-value');
    const value = marker ? (marker.getAttribute('data-h1') || '').trim() : '';

    // Bandito: koleksiyon başlığı artık grid'in üstünde H1 olarak duruyor
    // (.main-collection-grid__title). Filtre aktifse filtreye özel metne çevir.
    const targets = document.querySelectorAll('.main-collection-grid__title');
    targets.forEach(function (el) {
      if (el.dataset.originalTitle == null) {
        el.dataset.originalTitle = el.textContent.trim();
      }
      const next = value !== '' ? value : el.dataset.originalTitle;
      if (el.textContent !== next) {
        el.textContent = next;
      }
    });

    // Geriye dönük: sayfada ayrı bir başlık H1'i kalmışsa onu da güncelle.
    const h1 = findHeadingH1();
    if (h1 && !h1.classList.contains('main-collection-grid__title')) {
      if (h1.dataset.originalTitle == null) {
        h1.dataset.originalTitle = h1.textContent.trim();
      }
      const next = value !== '' ? value : h1.dataset.originalTitle;
      if (h1.textContent !== next) {
        h1.textContent = next;
      }
    }
  }

  let scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyFilterH1();
    });
  }

  function start() {
    applyFilterH1();

    // Watch the collection section for AJAX re-renders of the marker.
    const target =
      document.querySelector('#shopify-section-main') ||
      document.querySelector('collection-component') ||
      document.body;

    if (target) {
      const observer = new MutationObserver(scheduleApply);
      observer.observe(target, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['data-h1'],
      });
    }

    // Fallback: also react to the standard collection update event.
    document.addEventListener('shopify:collection:update', function (event) {
      const promise = event.detail && event.detail.promise;
      if (promise && typeof promise.then === 'function') {
        promise.then(scheduleApply).catch(scheduleApply);
      } else {
        scheduleApply();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
